import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment }  from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private  baseUrl=environment.baseUrl+"/";

  constructor(private http:HttpClient) { }

  authenticate(username: string, password:string): Observable<HttpEvent<any>> {
    const formData = JSON.stringify({
      "username": username,
      "password": password
    });

    // Set the Content-Type header to application/json
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    const req = new HttpRequest('POST', `${this.baseUrl}login`, formData, {
      headers: headers,
      responseType: 'json'
    });

    return this.http.request(req);
  }

  isUserLoggedIn() {
    let user = sessionStorage.getItem('username')
  //  console.log(!(user === null))
    return !(user === null)
  }

  logOut() {
    sessionStorage.removeItem('username')
  }
}
